<script lang="ts">
  let {
    installmentCount = $bindable(2),
    installmentInterval = $bindable(1),
  } = $props<{
    installmentCount: number;
    installmentInterval: number;
  }>();
</script>

<div class="grid grid-cols-1 sm:grid-cols-2 gap-3 divider pt-3">
  <div>
    <label class="label" for="ic">Nº de parcelas</label>
    <input id="ic" type="number" min="2" max="120" class="input" bind:value={installmentCount} />
  </div>
  <div>
    <label class="label" for="ii">Intervalo (meses)</label>
    <input id="ii" type="number" min="1" max="12" class="input" bind:value={installmentInterval} />
  </div>
  <p class="text-xs text-muted col-span-full">
    💡 Será criada uma transação para cada parcela com a descrição "(1/{installmentCount})", "(2/{installmentCount})"…
  </p>
</div>
